import { useMemo } from "react";
import { ExtractedContract } from "../../types/contract";

export const useContractResolution = (
  selectedContract: ExtractedContract | null,
  finalContracts: ExtractedContract[],
  conflictResolutions: Map<
    number,
    { building: "keep" | "update" | null; owner: "keep" | "update" | null }
  >
) => {
  // 現在の契約のresolution状態を取得
  const currentContractIdx = useMemo(() => {
    if (!selectedContract) return -1;
    return finalContracts.findIndex((c) => c.id === selectedContract.id);
  }, [selectedContract, finalContracts]);

  const currentResolution = useMemo(() => {
    if (currentContractIdx === -1) return null;
    return conflictResolutions.get(currentContractIdx);
  }, [currentContractIdx, conflictResolutions]);

  return {
    currentContractIdx,
    currentResolution,
  };
};